import StandardLabelTag from 'component/StandardLabelTag';
import { useEffect, useState } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useDoubleTap } from 'use-double-tap';
import './style.scss';
import Popular from '../../assets/svg/popular.svg';
import TaffiChoice from '../../assets/svg/taffi_choice.svg';
import BestSeller from '../../assets/svg/best_seller.svg';
import LimitedTime from '../../assets/svg/limited_time.svg';
import Exclusive from '../../assets/svg/exclusive.svg';
import Featured from '../../assets/svg/featured.svg';
import { StyleItemLabel } from './types';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../redux/store';
import { getProductTrackingData } from '../../utils/trackUtils';
import { setTrackingData } from '../../redux/analytic/analytic.slice';
import CanvasLayoutStyle from 'containers/style_detail/canvas_layout_style';

const blankImage = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

interface FeedItemProps {
    heightContent: any;
    listItems: any[];
    setActiveItem: any;
    handleClick: any;
    itemIndex: any;
    inputSearch: any;
    handleMultiImage: any;
    setSwiper?: any;
    isReviewing?: boolean;
}

const FeedItem = ({
    heightContent,
    listItems,
    setActiveItem,
    handleClick,
    itemIndex,
    inputSearch,
    handleMultiImage,
    setSwiper,
    isReviewing,
}: FeedItemProps) => {
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const dispatch = useAppDispatch();
    const [trackingItem, setTrackingItem] = useState<any>(null);

    const bind = useDoubleTap((event: any) => {
        const item = trackingItem ?? listItems[0];
        const style = listItems[0];
        dispatch(setTrackingData(getProductTrackingData(userDetail, item, style)));
        handleClick(event.target.currentSrc || '');
    });
    const pagination = {
        clickable: true,
    };
    const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();

    const handleExternalChangeSlide = (newSlideIndexToShow) => {
        swiperInstance?.slideTo(newSlideIndexToShow);
    };

    useEffect(() => {
        handleExternalChangeSlide(0);
        //eslint-disable-next-line
    }, [inputSearch, itemIndex]);

    useEffect(() => {
        if (itemIndex) swiperInstance?.slideTo(itemIndex);
    }, [itemIndex, swiperInstance]);

    const getLabelText = (label) => {
        switch (label) {
        case StyleItemLabel.POPULAR:
            return { name: 'Popular', icon: Popular };
        case StyleItemLabel.TAFFI_CHOICE:
            return { name: "Taffi's Choice", icon: TaffiChoice };
        case StyleItemLabel.BEST_SELLER:
            return { name: 'Best Seller', icon: BestSeller };
        case StyleItemLabel.LIMITED_TIME:
            return { name: 'Limited Time', icon: LimitedTime };
        case StyleItemLabel.EXCLUSIVE:
            return { name: 'Exclusive', icon: Exclusive };
        case StyleItemLabel.FEATURED:
            return { name: 'Featured', icon: Featured };
        default:
            return null;
        }
    };

    return (
        <div className="items">
            <Swiper
                pagination={pagination}
                onSlideChange={(e) => {
                    setActiveItem(e.activeIndex);
                    setTrackingItem(listItems[e.activeIndex]);
                    handleMultiImage();
                }}
                onSwiper={(swiper) => {
                    setSwiperInstance(swiper);
                    if (setSwiper) {
                        setSwiper(swiper);
                    }
                }}
            >
                {listItems.map((item) => {
                    // if (!item?.data?.images[0]) {
                    //     return null
                    // }

                    return (
                        <SwiperSlide key={item.id}>
                            <div
                                style={{
                                    width: '100%',
                                    height: `${heightContent}px`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {isReviewing && item.collection === 'styles' && item.data?.imageJson?.length ? (
                                    <CanvasLayoutStyle
                                        style={item.data}
                                        items={item.data.items}
                                        heightContent={heightContent - 50}
                                    />
                                ) : (
                                    <div style={{ height: `${heightContent - 50}px` }}>
                                        {Boolean(item?.data?.brand?.name) && (
                                            <span style={{ position: 'absolute', top: 0, left: 0 }}>
                                                <StandardLabelTag
                                                    label={{
                                                        name: item?.data?.brand?.name,
                                                        icon: item?.data?.brand?.imageUrl,
                                                        background: '#F2F2F2',
                                                    }}
                                                />
                                            </span>
                                        )}
                                        {Boolean(item?.data?.labels?.length) && (
                                            <span style={{ position: 'absolute', top: 0, right: 0 }}>
                                                <StandardLabelTag label={getLabelText(item.data.labels[0].name)!} />
                                            </span>
                                        )}
                                        <img
                                            src={
                                                item?.data?.images
                                                    ? item?.data?.images[item.indexSelect] || blankImage
                                                    : blankImage
                                            }
                                            style={{
                                                width: 'auto',
                                                height: '100%',
                                                objectFit: 'scale-down',
                                                margin: 'auto',
                                                maxWidth: '100%',
                                            }}
                                            alt="style img"
                                            onDoubleClick={() => {
                                                handleClick(item?.data?.images[0] || '');
                                            }}
                                            {...bind}
                                        />
                                    </div>
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};
export default FeedItem;
